<script setup lang="ts">
const props = defineProps<{
  active?: boolean
}>()
</script>

<template>
  <div
    class="group bg-background-soft border-stroke-inactive flex min-h-[146px] w-[124px] shrink-0 grow-0 flex-col overflow-hidden rounded-[6px] border text-white data-[active=true]:bg-[#202E4A]"
    :data-active="props.active"
  >
    <div
      class="border-stroke-inactive bg-background-inactive border-b px-2 py-1 text-sm group-data-[active=true]:bg-[#202E4A]"
      v-if="$slots.header"
    >
      <slot name="header"></slot>
    </div>
    <div class="grow p-1 text-white/80"><slot></slot></div>
    <div class="pt-1" v-if="$slots.footer"><slot name="footer"></slot></div>
  </div>
</template>

<style scoped></style>
